const leaders = [
	{
		organization: 'Ammolite Strategies Inc.',
		logo: require('../images/dinner-with-leaders/ammolite-strategies.png'),
		leaders: [
			{
				firstName: 'Cara',
				lastName: 'Wolf',
				position: 'CEO',
			},
		],
	},
	{
		organization: 'ATB',
		logo: require('../images/dinner-with-leaders/atb.png'),
		leaders: [
			{
				firstName: 'Craig ',
				lastName: 'Hampson',
				position: 'Senior VP, Head of Retail Markets',
			},
			{
				firstName: 'Nav',
				lastName: 'Dhunay',
				position: 'Managing Director of Innovation',
			},
			{
				firstName: 'Paul',
				lastName: 'Norris',
				position: 'VP of Retail Credit',
			},
		],
	},
	{
		organization: 'Avnet Inc.',
		logo: require('../images/dinner-with-leaders/avnet.png'),
		leaders: [
			{
				firstName: 'Quenton',
				lastName: 'Hall',
				position: 'Senior Field Applications Engineer',
			},
		],
	},
	{
		organization: 'Barre Belle',
		logo: require('../images/dinner-with-leaders/barre-belle.png'),
		leaders: [
			{
				firstName: 'Kristi ',
				lastName: 'Stuart',
				position: 'Founder',
			},
		],
	},
	{
		organization: 'Benevity',
		logo: require('../images/dinner-with-leaders/benevity.png'),
		leaders: [
			{
				firstName: 'Edmond',
				lastName: 'Palao',
				position: 'Manager, Client Success',
			},
			{
				firstName: 'Jennifer',
				lastName: 'Munro',
				position: 'Controller',
			},
		],
	},
	{
		organization: 'Calgary Chamber of Commerce',
		logo: require('../images/dinner-with-leaders/calgary-chamber.png'),
		leaders: [
			{
				firstName: 'Sandip',
				lastName: 'Lalli',
				position: 'President and CEO',
			},
		],
	},
	{
		organization: 'Calgary Foundation',
		logo: require('../images/dinner-with-leaders/calgary-foundation.png'),
		leaders: [
			{
				firstName: 'Eva',
				lastName: 'Friesen',
				position: 'CEO',
			},
		],
	},
	{
		organization: 'Calgary Opera Company',
		logo: require('../images/dinner-with-leaders/calgary-opera.png'),
		leaders: [
			{
				firstName: 'Bonnie',
				lastName: 'Dupont',
				position: 'Corporate Director',
			},
		],
	},
	{
		organization: 'Enbridge',
		logo: require('../images/dinner-with-leaders/enbridge.jpg'),
		leaders: [
			{
				firstName: 'Max',
				lastName: 'Chan',
				position: 'VP Treasury',
			},
		],
	},
	{
		organization: 'Encana',
		logo: require('../images/dinner-with-leaders/encana.png'),
		leaders: [
			{
				firstName: 'Dave',
				lastName: 'Lye',
				position: 'VP External Affairs',
			},
		],
	},
	{
		organization: 'Energy Disruptors/McLaren Dion Edge',
		logo: require('../images/dinner-with-leaders/energy-disruptors.png'),
		leaders: [
			{
				firstName: 'Graeme',
				lastName: 'Edge',
				position: 'Founder',
			},
		],
	},
	{
		organization: 'EY',
		logo: require('../images/dinner-with-leaders/ey.png'),
		leaders: [
			{
				firstName: 'Harm',
				lastName: 'Cassam',
				position: 'Executive Director of Forensics Accounting',
			},
		],
	},
	{
		organization: 'GLJ Petroleum Consultant',
		logo: require('../images/dinner-with-leaders/glj-petroleum-consultants.png'),
		leaders: [
			{
				firstName: 'Caralyn',
				lastName: 'Bennett',
				position: 'Executive VP and Chief Strategy Officer',
			},
		],
	},
	{
		organization: 'GrowME Marketing',
		logo: require('../images/dinner-with-leaders/growme.jpg'),
		leaders: [
			{
				firstName: 'Tarek',
				lastName: 'Mohajer',
				position: 'Founder',
			},
		],
	},
	{
		organization: 'Imagination Group of Companies',
		logo: require('../images/dinner-with-leaders/imagination.png'),
		leaders: [
			{
				firstName: 'Colby',
				lastName: 'Delorme',
				position: 'President',
			},
		],
	},
	{
		organization: 'MATCO Investments',
		logo: require('../images/dinner-with-leaders/matco.png'),
		leaders: [
			{
				firstName: 'Mike',
				lastName: 'Tims',
				position: 'Vice Chairman',
			},
		],
	},
	{
		organization: 'Melrose',
		logo: require('../images/dinner-with-leaders/melrose.png'),
		leaders: [
			{
				firstName: 'Wayne',
				lastName: 'Leong',
				position: 'Owner and President',
			},
		],
	},
	{
		organization: 'NBC',
		logo: require('../images/dinner-with-leaders/nbc.png'),
		leaders: [
			{
				firstName: 'Arun',
				lastName: 'Chandrasekaran',
				position: 'Head of Energy Investment Banking',
			},
		],
	},
	{
		organization: 'Nutrien',
		logo: require('../images/dinner-with-leaders/nutrien.png'),
		leaders: [
			{
				firstName: 'Debasis',
				lastName: 'Bhaumik',
				position: 'VP IT',
			},
			{
				firstName: 'Saskia',
				lastName: 'Houwen',
				position: 'Director, Business Intelligence',
			},
		],
	},
	{
		organization: 'NuVista Energy',
		logo: require('../images/dinner-with-leaders/nuvista.jpg'),
		leaders: [
			{
				firstName: 'Jonathan',
				lastName: 'Wright',
				position: 'President and CEO',
			},
		],
	},
	{
		organization: 'PBA Land Development Ltd.',
		logo: require('../images/dinner-with-leaders/pba.jpg'),
		leaders: [
			{
				firstName: 'Patricia',
				lastName: 'Phillips',
				position: 'CEO',
			},
		],
	},
	{
		organization: 'PrairieSky Royalty Ltd.',
		logo: require('../images/dinner-with-leaders/prairie-sky.jpg'),
		leaders: [
			{
				firstName: 'Pam',
				lastName: 'Kazeil',
				position: 'VP Finance and CFO',
			},
		],
	},
	{
		organization: 'Rockmount Financial Corp',
		logo: require('../images/dinner-with-leaders/rockmount.png'),
		leaders: [
			{
				firstName: 'Khalid',
				lastName: 'Asaria',
				position: 'Analyst',
			},
			{
				firstName: 'Russell ',
				lastName: 'Kalmacoff',
				position: 'President',
			},
		],
	},
	{
		organization: 'Secure Energy Services',
		logo: require('../images/dinner-with-leaders/secure-energy-services.jpg'),
		leaders: [
			{
				firstName: 'Heidi',
				lastName: 'Kaus',
				position: 'VP Corporate Finance',
			},
		],
	},
	{
		organization: 'Suncor Energy',
		logo: require('../images/dinner-with-leaders/suncor.png'),
		leaders: [
			{
				firstName: 'Ginny',
				lastName: 'Flood',
				position: 'VP Government Relations',
			},
		],
	},
	{
		organization: 'Tool Shed Brewing',
		logo: require('../images/dinner-with-leaders/toolshed.jpg'),
		leaders: [
			{
				firstName: 'Graham',
				lastName: 'Sherman',
				position: 'Co-founder',
			},
		],
	},
	{
		organization: 'Tudor Pickering Holt & Co. Securities Canada',
		logo: require('../images/dinner-with-leaders/tudorpickering.png'),
		leaders: [
			{
				firstName: 'Hilary',
				lastName: 'Foulkes',
				position: 'Chair',
			},
		],
	},
	{
		organization: 'Vertex Downhole',
		logo: require('../images/dinner-with-leaders/vertex-downhole.png'),
		leaders: [
			{
				firstName: 'Rick',
				lastName: 'Filipovic',
				position: 'CEO',
			},
		],
	},
	{
		organization: 'WestJet',
		logo: require('../images/dinner-with-leaders/westjet.png'),
		leaders: [
			{
				firstName: 'Charles',
				lastName: 'Duncan',
				position: 'Executive VP and Chief Strategy Officer',
			},
		],
	},
	{
		organization: 'Work Nicer',
		logo: require('../images/dinner-with-leaders/work-nicer.png'),
		leaders: [
			{
				firstName: 'Alex',
				lastName: 'Putici',
				position: 'CEO',
			},
		],
	},
	{
		organization: 'University of Calgary',
		logo: require('../images/dinner-with-leaders/ucalgary.png'),
		leaders: [
			{
				firstName: 'Janaka',
				lastName: 'Ruwanpura',
				position: 'Vice Provost International',
			},
			{
				firstName: 'Leona',
				lastName: 'Lachance',
				position: 'Associate VP, Development',
			},
			{
				firstName: 'Nuvyn',
				lastName: 'Peters',
				position: 'Vice President, Development',
			},
			{
				firstName: 'Glenda ',
				lastName: 'Reynolds',
				position: 'Director of CCAL',
			},
			{
				firstName: 'Aleem',
				lastName: 'Bharwani',
				position: 'Director of Cumming School of Medicine',
			},
			{
				firstName: 'Joelle',
				lastName: 'Foster',
				position: 'Executive Director of Hunter Hub',
			},
		],
	},
]

export default leaders
